import { useTheme } from '@h2oai/ui-kit';
import { useEffect, useState } from 'react';

import { GetSAMLConfigRequest } from '../../admin-center/gen/idp_management/idp_management_pb';
import { useAdminCenterService } from '../../admin-center/hooks';
import { useUser } from '../../utils/hooks';
import { buildUserContext } from './common/utils';
import {
  IdpConnectionDetailsStyles,
  infoLabelStyles,
  infoValueStyles,
  overlayContainerStyles,
} from './components/IdpManagement/IdpManagement.styles';
import PageWrapper from './PageWrapper';

type SAMLConfig = {
  type?: string;
  url?: string;
  destination?: string;
  audience?: string;
  href?: string;
};

export default function IdpManagement() {
  const service = useAdminCenterService();
  const theme = useTheme();
  const user = useUser();
  const [samlConfig, setSamlConfig] = useState<SAMLConfig | null>(null);
  const [samlConfigError, setSamlConfigError] = useState<string | null>(null);

  const fetchSAMLConfigData = async () => {
    try {
      const userContext = await buildUserContext(user);
      const samlConfigReq: GetSAMLConfigRequest = {
        userContext: userContext,
      };
      const samlConfigResponse = await service.getSAMLConfigRequest(samlConfigReq);
      const config: SAMLConfig = {
        type: samlConfigResponse.samlConfig?.type ?? 'Unknown',
        url: samlConfigResponse.samlConfig?.url ?? 'Unknown',
        destination: samlConfigResponse.samlConfig?.destination ?? 'Unknown',
        audience: samlConfigResponse.samlConfig?.audience ?? 'Unknown',
        href: samlConfigResponse.samlConfig?.href ?? 'Unknown',
      };

      setSamlConfig(config);
    } catch (error: any) {
      setSamlConfigError(error?.message || '');
    }
  };
  useEffect(() => {
    fetchSAMLConfigData();
  }, []);

  const showNoAccess =
    !!samlConfigError &&
    (samlConfigError.toLowerCase().includes('no matching idp found') ||
      samlConfigError.toLowerCase().includes('not found'));

  return (
    <PageWrapper>
      {showNoAccess && (
        <div style={overlayContainerStyles()}>
          <div style={{ fontSize: '48px' }}>⚠️</div>
          <div style={{ fontSize: '24px', fontWeight: 600 }}>Customer Identity Provider has not been configured</div>
        </div>
      )}
      <div style={IdpConnectionDetailsStyles(theme)}>
        <div>
          <p style={infoLabelStyles(theme)}>SAML Type:</p>
          <p style={infoValueStyles(theme)}>{samlConfig?.type ?? '-'}</p>
        </div>
        <div>
          <p style={infoLabelStyles(theme)}>URL:</p>
          <p style={infoValueStyles(theme)}>{samlConfig?.url ?? '-'}</p>
        </div>
        <div>
          <p style={infoLabelStyles(theme)}>Destination:</p>
          <p style={infoValueStyles(theme)}>{samlConfig?.destination ?? '-'}</p>
        </div>
        <div>
          <p style={infoLabelStyles(theme)}>Audience:</p>
          <p style={infoValueStyles(theme)}>{samlConfig?.audience ?? '-'}</p>
        </div>
        <div>
          <p style={infoLabelStyles(theme)}>Href:</p>
          <p style={infoValueStyles(theme)}>{samlConfig?.href ?? '-'}</p>
        </div>
      </div>
    </PageWrapper>
  );
}
